import React, { useEffect, useState } from "react";

import { useParams } from "react-router";

import npiApi from "apis/npi";
import {
  Button,
  Typography,
  SubHeader,
  Table,
  PageLoader,
} from "clearsense-ui/components";
import groupNpiRecordDetailsByCategory from "utils/groupNpiRecordDetailsByCategory";

import BasicInformation from "./BasicInformation";

import {
  HEALTH_INFORMATION_EXCHANGE_TABLE_COLUMNS,
  OTHER_IDENTIFIER_TABLE_COLUMNS,
  TAXONOMY_TABLE_COLUMNS,
} from "../constants";

const Show = () => {
  const { npi } = useParams();
  const [loading, setLoading] = useState(true);
  const [npiRecord, setNpiRecord] = useState({});

  const fetchNPIRecords = async () => {
    try {
      const { data } = await npiApi.show(npi);
      setNpiRecord(data);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNPIRecords();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="cs-ui-container">
      <div className="mx-8">
        <Typography style="h2" className="mt-4">
          Provider Information for {npi}
        </Typography>
        <SubHeader
          className="mt-8"
          breadcrumbs={[
            {
              label: "NPI Registry",
              link: "/management/reference-data/npi-registry",
            },
            { label: "NPI View", link: "#" },
          ]}
        />
        <hr />
        <span className="mt-4">
          Please note: Issuance of an NPI does not ensure of validate that the
          Healthcare Provider is Licenced or Credentialed. For more information
          please refer to&nbsp;
          <Button
            label="NPI: What You Need to Know"
            style="link"
            size="default"
            href="https://www.cms.gov/Outreach-and-Education/Medicare-Learning-Network-MLN/MLNProducts/Downloads/NPI-What-You-Need-To-Know.pdf"
          />
        </span>
        <BasicInformation npiRecord={npiRecord} />
        <Typography style="h3" className="mt-4">
          Health Information Exchange
        </Typography>
        <Table
          fixedHeight
          columnData={HEALTH_INFORMATION_EXCHANGE_TABLE_COLUMNS}
          rowData={npiRecord.endpoints}
          rowKey="id"
        />
        <Typography style="h3" className="mt-4">
          Other Identifiers
        </Typography>
        <Table
          fixedHeight
          columnData={OTHER_IDENTIFIER_TABLE_COLUMNS}
          rowData={groupNpiRecordDetailsByCategory(
            npiRecord,
            "other_provider_identifier"
          )}
        />
        <Typography style="h3" className="mt-4">
          Taxonomy
        </Typography>
        <Table
          fixedHeight
          columnData={TAXONOMY_TABLE_COLUMNS}
          rowData={groupNpiRecordDetailsByCategory(
            npiRecord,
            "healthcare_provider",
            "provider_license"
          )}
        />
      </div>
    </div>
  );
};

export default Show;
